// ============================================================
// IMPORTS
// ============================================================
import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";
import {
  CreateDeployment,
  EndDeployment,
} from "../Types/Employee/EmployeeDeployments";

// ============================================================
// REACT QUERY KEYS
// ============================================================
export const EMPLOYEE_DEPLOYMENTS_QUERY_KEY = ["employee-deployments"];
export const VIEW_EMPDEPLOYMENTS_QUERY_KEY = ["view-employee-deployments"];
export const VIEW_EMPDEPLOYMENTS_MAIN_QUERY_KEY = [
  "view-employee-deployments-main",
];

// ============================================================
// EMPLOYEE DEPLOYMENT SERVICE
// ============================================================

export const employeeDeploymentService = {
  // ----------------------------------------------------------
  // CREATE EMPLOYEE DEPLOYMENT
  // ----------------------------------------------------------
  createEmployeeStatus: async (payload: CreateDeployment) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/employee-deployments", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  // ----------------------------------------------------------
  // END EMPLOYEE DEPLOYMENT
  // ----------------------------------------------------------
  endDeployment: async (id: number, payload: EndDeployment) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/employee-deployments/${id}`,
        payload,
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  // ----------------------------------------------------------
  // VIEW EMPLOYEE DEPLOYMENTS BY EMPLOYEE NUMBER
  // ----------------------------------------------------------
  ViewByEmployeeNo: async (emp_no: string) => {
    const response = await api.get(
      `api/view-employee-deployments/${emp_no}/emp_no`,
    );

    return response.data.data;
  },

  // ----------------------------------------------------------
  // VIEW EMPLOYEE MAIN DEPLOYMENT
  // ----------------------------------------------------------
  ViewEmployeeMain: async (emp_no: string) => {
    const response = await api.get(
      `api/view-employee-deployments/${emp_no}/main`,
    );

    return response.data.data;
  },

  // ----------------------------------------------------------
  // TOGGLE EMPLOYEE DEPLOYMENT STATUS
  // ----------------------------------------------------------
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(
          `api/employee-deployments/${id}/toggle-status`,
          {}, // Empty request body
          {
            headers: getAuthHeaders(),
          },
        )
        .then((res) => res.data),
    ),
};
